<template>
  <div class="topNavigation row">
    <div class="pageSwitcher">
      <div
          class="item"
          :class="{active: viewMode === 'one-page'}"
          @click="$emit('changeViewMode', 'one-page')"
      >
        One Page View
      </div>
      <div
          class="item"
          :class="{active: viewMode === 'two-page'}"
          @click="$emit('changeViewMode', 'two-page')"
      >
        Two Pages View</div>
    </div>
    <div class="bookmarked" @click="onClickBookmarkIcon">
      <IconBookmark :active="bookmarked"/>
    </div>
  </div>
</template>

<script>
import IconBookmark from "@/components/market/icons/IconBookmark";
export default {
  name: "TopNavigation",
  props: {
    viewMode: String,
    bookmarked: Boolean
  },
  components: {IconBookmark},
  methods: {
    onClickBookmarkIcon() {
      if (this.bookmarked) {
        this.$emit('removeBookmark')
      } else {
        this.$emit('addBookmark')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.topNavigation {
  .pageSwitcher {
    margin-left: auto;
    display: flex;
    align-items: center;
    overflow: hidden;
    .item {
      background-color: #E0E0E0;
      color: #333333;
      padding: 0px 15px;
      cursor: pointer;
      font-weight: bold;
      font-size: 10px;
      line-height: 30px;
      &:first-child {
        border-radius: 5px 0px 0px 5px;
      }
      &:last-child {
        border-radius: 0px 5px 5px 0px;
      }
      &.active {
        background-color: $mainGreen;
        color: #FFFFFF;
      }
    }
  }
  .bookmarked {
    margin-left: 15px;
    margin-top: 15px;
    margin-bottom: 10px;
  }
}
</style>